import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PasswordShowHide from './PasswordShowHide';
import FastModal from '../../components/FastModal';
import {Feedback} from '../../constants/dataEnum';
import {FormControl, AlertType, AlertPassword} from '../../constants/editUserEnum';
import withIntl from '../../lib/withIntl';
import {showLoading, hideLoading, showSnackbar, setIsAnyModalShow} from '../../stores/actions/appStateAction';
import {setSessionUser} from '../../stores/actions/sessionAction';
import {changePassword} from '../../stores/business/userManagementBusiness';
import './ModalChangePassword.scss';

function mapStateToProps(state) {
  return {
    sessionStateUser: state.sessionState.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActionShowLoading: bindActionCreators(showLoading, dispatch),
    appStateActionHideLoading: bindActionCreators(hideLoading, dispatch),
    appStateActionShowSnackbar: bindActionCreators(showSnackbar, dispatch),
    appStateActionSetIsAnyModalShow: bindActionCreators(setIsAnyModalShow, dispatch),
    sessionActionSetSessionUser: bindActionCreators(setSessionUser, dispatch),
    userManagementBusinessChangePassword: bindActionCreators(changePassword, dispatch),
  };
}

class ModalChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputOldPassword: '',
      inputNewPassword: '',
      inputConfirmNewPassword: '',
      alertOldPassword: {
        type: '',
        isShow: false,
      },
      alertNewPassword: {
        type: '',
        isShow: false,
      },
      alertConfirmNewPassword: {
        type: '',
        isShow: false,
      },
    };
  }

  componentDidMount() {
    const {appStateActionSetIsAnyModalShow} = this.props;

    appStateActionSetIsAnyModalShow(true);
  }

  validatePassword = (oldPassword, newPassword, repeatPassword) => {
    if (!oldPassword || !newPassword) {
      return;
    }

    if (oldPassword === newPassword) {
      this.setState({alertNewPassword: {type: AlertPassword.SAME_WITH_OLD_PASSWORD, isShow: true}});
    } else if (newPassword.length > 0 && newPassword.length < 8) {
      this.setState({alertNewPassword: {type: AlertPassword.TOO_SHORT, isShow: true}});
    } else if (newPassword.search(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\W\S_]{8,}$/) < 0) {
      this.setState({alertNewPassword: {type: AlertPassword.MUST_CONTAIN_FORMAT, isShow: true}});
    } else {
      this.setState({alertNewPassword: {type: '', isShow: false}});
    }

    if (!repeatPassword) {
      return;
    }

    if (newPassword !== repeatPassword) {
      this.setState({alertConfirmNewPassword: {type: AlertPassword.CONFIRM_PASSWORD_NOT_MATCH, isShow: true}});
    } else {
      this.setState({alertConfirmNewPassword: {type: '', isShow: false}});
    }
  };

  onChangeInputOldPassword = (event) => {
    const {inputNewPassword, inputConfirmNewPassword} = this.state;

    const txtPassword = event.value.trim();
    this.setState({
      alertOldPassword: {
        type: '',
        isShow: false,
      },
    });
    this.validatePassword(txtPassword, inputNewPassword, inputConfirmNewPassword);
    this.setState({inputOldPassword: txtPassword});
  };

  onChangeInputNewPassword = (event) => {
    const {inputOldPassword, inputConfirmNewPassword} = this.state;

    const txtPassword = event.value.trim();
    this.setState({
      alertNewPassword: {
        type: '',
        isShow: false,
      },
    });
    this.validatePassword(inputOldPassword, txtPassword, inputConfirmNewPassword);
    this.setState({inputNewPassword: txtPassword});
  };

  onChangeInputConfirmNewPassword = (event) => {
    const {inputOldPassword, inputNewPassword} = this.state;

    const txtPassword = event.value.trim();
    this.setState({
      alertConfirmNewPassword: {
        type: '',
        isShow: false,
      },
    });
    this.validatePassword(inputOldPassword, inputNewPassword, txtPassword);
    this.setState({inputConfirmNewPassword: txtPassword});
  };

  closeChangePasswordDialog = () => {
    const {onClose, appStateActionSetIsAnyModalShow} = this.props;

    this.setState({
      inputOldPassword: '',
      inputNewPassword: '',
      inputConfirmNewPassword: '',
      alertOldPassword: {
        type: '',
        isShow: false,
      },
      alertNewPassword: {
        type: '',
        isShow: false,
      },
      alertConfirmNewPassword: {
        type: '',
        isShow: false,
      },
    });

    onClose();
    appStateActionSetIsAnyModalShow(false);
  };

  updatePassword = async () => {
    const {
      sessionStateUser,
      appStateActionShowLoading,
      appStateActionHideLoading,
      appStateActionShowSnackbar,
      sessionActionSetSessionUser,
      userManagementBusinessChangePassword,
      intl,
    } = this.props;
    const {inputOldPassword, inputNewPassword} = this.state;

    const showLoadingText = intl.formatMessage({id: 'loading.userManagement.changePasswordDialog.doChangePassword'});

    appStateActionShowLoading(showLoadingText);

    const response = await userManagementBusinessChangePassword(
      sessionStateUser.userId,
      inputOldPassword,
      inputNewPassword,
    );

    if (response) {
      const newUserProfile = {...sessionStateUser};
      newUserProfile.decryptedPassword = inputNewPassword;
      sessionActionSetSessionUser(newUserProfile);

      const changePasswordSuccessText = intl.formatMessage({id: 'userManagement.changePassword.success'});

      appStateActionShowSnackbar(Feedback.SUCCESS, changePasswordSuccessText, 2000);

      this.closeChangePasswordDialog();
    } else {
      this.setState({
        alertOldPassword: {
          type: AlertPassword.OLD_PASSWORD_NOT_MATCH,
          isShow: true,
        },
      });
    }

    appStateActionHideLoading();
  };

  showAlertDialog = (type) => {
    const {intl} = this.props;
    const {alertNewPassword, alertOldPassword, alertConfirmNewPassword} = this.state;

    let content = '';

    switch (type) {
      case AlertType.OLD_PASSWORD:
        if (alertOldPassword.isShow) {
          switch (alertOldPassword.type) {
            case AlertPassword.OLD_PASSWORD_NOT_MATCH:
              content = intl.formatMessage({id: 'userManagement.changePassword.oldPasswordNotSame'});
              break;
            default:
              break;
          }
        }
        break;
      case AlertType.NEW_PASSWORD:
        if (alertNewPassword.isShow) {
          switch (alertNewPassword.type) {
            case AlertPassword.SAME_WITH_OLD_PASSWORD:
              content = intl.formatMessage({id: 'userManagement.changePassword.sameWithOldPassword'});
              break;
            case AlertPassword.TOO_SHORT:
              content = intl.formatMessage({id: 'userManagement.createNewUser.tooshortPassword'});
              break;
            case AlertPassword.MUST_CONTAIN_FORMAT:
              content = intl.formatMessage({id: 'userManagement.createNewUser.mustContainFormat'});
              break;
            default:
              break;
          }
        }
        break;
      case AlertType.CONFIRM_NEW_PASSWORD:
        if (alertConfirmNewPassword.isShow) {
          switch (alertConfirmNewPassword.type) {
            case AlertPassword.CONFIRM_PASSWORD_NOT_MATCH:
              content = intl.formatMessage({id: 'userManagement.changePassword.confirmPasswordNotSame'});
              break;
            default:
              break;
          }
        }
        break;
      default:
        break;
    }

    return content;
  };

  disabledSaveBtn = () => {
    const {
      inputOldPassword,
      inputNewPassword,
      inputConfirmNewPassword,
      alertNewPassword,
      alertOldPassword,
      alertConfirmNewPassword,
    } = this.state;

    if (inputOldPassword === '') return true;
    if (inputNewPassword === '') return true;
    if (inputConfirmNewPassword === '') return true;
    if (inputConfirmNewPassword !== inputNewPassword) return true;
    if (alertNewPassword.isShow) return true;
    if (alertOldPassword.isShow) return true;
    if (alertConfirmNewPassword.isShow) return true;
    return false;
  };

  render() {
    const {
      inputOldPassword,
      inputNewPassword,
      inputConfirmNewPassword,
      alertNewPassword,
      alertOldPassword,
      alertConfirmNewPassword,
    } = this.state;
    const {intl, showModal, onClose, appStateActionSetIsAnyModalShow} = this.props;

    const buttonUpdate = intl.formatMessage({id: 'userManagement.changePassword.buttonUpdate'});
    const buttonCancel = intl.formatMessage({id: 'userManagement.changePassword.buttonCancel'});

    this.btnAction = [
      {
        text: buttonUpdate,
        style: 'primary',
        handlerClick: this.updatePassword,
        disabled: this.disabledSaveBtn(),
      },
      {
        text: buttonCancel,
        style: 'secondary',
        handlerClick: () => {
          onClose();
          appStateActionSetIsAnyModalShow(false);
        },
      },
    ];

    const alertMessageOldPassword = this.showAlertDialog(AlertType.OLD_PASSWORD);
    const alertMessageNewPassword = this.showAlertDialog(AlertType.NEW_PASSWORD);
    const alertMessageConfirmNewPassword = this.showAlertDialog(AlertType.CONFIRM_NEW_PASSWORD);

    this.content = (
      <div className="ModalChangePassword">
        <div className="label-content-instruction">
          {intl.formatMessage({id: 'userManagement.changePassword.content'})}
        </div>
        <div className="separation" />
        <PasswordShowHide
          id="change-password-old"
          labelHeader={FormControl.OLD_PASSWORD.LABEL_HEADER}
          placeholder={FormControl.OLD_PASSWORD.PLACEHOLDER}
          onChange={this.onChangeInputOldPassword}
          value={inputOldPassword}
          disabled={false}
          alertMessageContent={alertOldPassword.isShow ? alertMessageOldPassword : ''}
          onInputKeyPressed={() => {
            if (!this.disabledSaveBtn()) this.updatePassword();
          }}
        />
        <span className="label-suggestion">
          <span>{intl.formatMessage({id: 'userManagement.changePassword.titleSuggestion'})}</span>
          <br />
          <span>{intl.formatMessage({id: 'userManagement.changePassword.contentSuggestion'})}</span>
        </span>
        <PasswordShowHide
          id="change-password-new"
          labelHeader={FormControl.NEW_PASSWORD.LABEL_HEADER}
          placeholder={FormControl.NEW_PASSWORD.PLACEHOLDER}
          onChange={this.onChangeInputNewPassword}
          value={inputNewPassword}
          disabled={false}
          alertMessageContent={alertNewPassword.isShow ? alertMessageNewPassword : ''}
          onInputKeyPressed={() => {
            if (!this.disabledSaveBtn()) this.updatePassword();
          }}
        />
        <PasswordShowHide
          id="change-password-confirm"
          labelHeader={FormControl.CONFIRM_NEW_PASSWORD.LABEL_HEADER}
          placeholder={FormControl.CONFIRM_NEW_PASSWORD.PLACEHOLDER}
          onChange={this.onChangeInputConfirmNewPassword}
          value={inputConfirmNewPassword}
          disabled={false}
          alertMessageContent={alertConfirmNewPassword.isShow ? alertMessageConfirmNewPassword : ''}
          onInputKeyPressed={() => {
            if (!this.disabledSaveBtn()) this.updatePassword();
          }}
        />
      </div>
    );

    return (
      <FastModal
        header={intl.formatMessage({id: 'userManagement.changePassword.textHeader'})}
        content={this.content}
        btnAction={this.btnAction}
        show={showModal}
        className="create-rename"
        isValid
        closeDisabled
      />
    );
  }
}

ModalChangePassword.propTypes = {
  sessionStateUser: PropTypes.object.isRequired,
  appStateActionShowLoading: PropTypes.func.isRequired,
  appStateActionHideLoading: PropTypes.func.isRequired,
  appStateActionShowSnackbar: PropTypes.func.isRequired,
  appStateActionSetIsAnyModalShow: PropTypes.func.isRequired,
  sessionActionSetSessionUser: PropTypes.func.isRequired,
  userManagementBusinessChangePassword: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
};

ModalChangePassword.defaultProps = {
  showModal: false,
  onClose: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(ModalChangePassword));
